import Carousel from '@components/Carousel'
import { useEffect, useState, useMemo } from 'react'
import { mediaHelperImages, getImageUrls } from '@/utils/imageLoaders'

const FeaturedPost = () => {
  const carouselImages = useMemo(() => getImageUrls(mediaHelperImages), [])
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        return prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
      })
    }, 5000)
    return () => clearInterval(interval)
  }, [carouselImages.length])

  return (
    <article className="post featured p-6 mb-6 bg-white shadow-lg rounded-lg w-full">
      <header className="major mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Media Helper</h2>
        <p className="text-gray-600 mt-2">
          A powerful SaaS platform designed to streamline social media content
          management and automation across multiple platforms (Instagram,
          Facebook, LinkedIn, Twitter).
        </p>
      </header>
      <header className="mb-4">
        <h2 className="text-xl font-semibold text-gray-700">Key Features</h2>
      </header>
      <ul className="list-disc list-inside text-gray-600 mb-4">
        <li>Multi-platform support (Instagram, Facebook, LinkedIn, Twitter)</li>
        <li>
          AI-powered caption generation with DeepSeek AI and image analysis
        </li>
        <li>Multi-platform scheduling and automated publishing</li>
        <li>
          OAuth 2.0 authentication with AES-256-GCM encrypted token storage
        </li>
        <li>
          Firebase-based architecture (Cloud Functions, Firestore, Storage)
        </li>
      </ul>
      <div className="image main block mb-4 -mx-6 w-[calc(100%+3rem)] min-h-[600px]">
        <Carousel imgSrc={carouselImages[currentImageIndex]} />
      </div>
      <ul className="actions special">
        <li>
          <a
            href="https://github.com/luisVargasGu/media-helper"
            target="_blank"
            className="button bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition duration-300"
          >
            View project details
          </a>
        </li>
      </ul>
    </article>
  )
}

export default FeaturedPost
